<template>
  <div class="systembox">
    <i-tabs name="中国版" @on-click="tabchange">
      <i-tabPane value="typeitem" v-for="item of types" :key="item" :label="item">
        <div>
          <!-- 当前体系版本 -->
          <div class="edition">
            <i-row>
              <i-col :xs="24" :sm="24" :md="{ span: 3, offset: 18 }" :lg="{ span: 3, offset: 18 }">
                <i-button class="add-button" type="success" @click="addSystem">
                  <i class="iconfont icon-tianjia"></i>
                  新增一级指标
                </i-button>
              </i-col>
            </i-row>
          </div>
          <div class="article-main">
            <i-table
              class="article-table"
              :columns="columns"
              :data="articleData"
              stripe
              border
              row-key="id"
              @on-selection-change="selection_change"
            >
              <!-- 操作的slot按钮 -->
              <template slot-scope="{ row }" slot="operation">
                <!--删除-->
                <i-button type="error" class="article-button" @click="DeleteShuxing(row)">
                  <i class="iconfont icon-shanchu operate-icon"></i>
                  删除
                </i-button>
                <i-button v-show="!row.parent_id" type="success" class="article-button" @click="addSecondZhibiao(row)">
                  <i class="iconfont icon-tianjia operate-icon"></i>
                  添加二级指标
                </i-button>
                <i-button type="warning" class="article-button" @click="handleUpdateSystem(row)">
                  <i class="iconfont icon-weibiaoti2010104 operate-icon"></i>
                  修改
                </i-button>
              </template>
            </i-table>
          </div>
        </div>
      </i-tabPane>
    </i-tabs>
    <!-- 新增一级指标 -->
    <i-add-system
      :system="isShowAddSystem"
      @cancelAddCategory="cancelAddCategory"
      @confirmAdd="confirmAdd"
      :system-name="addSystemName"
      :system-type-name="addSystemTypeName"
      :categorytype="categorytype"
    ></i-add-system>
    <!-- 添加二级指标 -->
    <i-new-system
      :isShowAddSystem="isShowNewSystem"
      @cancelAddCategory="cancelAddCategory"
      @confirmAdd="confirmAdd"
      :system-name="addSystemName"
      :system-type-name="addSystemTypeName"
      :system-parent-id="parentId"
    ></i-new-system>
    <!-- 修改分类 -->
    <i-update-system
      :updateSystem="updateSystem"
      @confirmUpdate="confirmUpdate"
      @cancelUpdateSystem="cancelUpdateSystem"
      :system-id="updateSystemId"
      :system-name="updateSystemName"
      :system-path="systemPath"
      :system-meta-info="metaInfo"
      :system-type-name="typeName"
    ></i-update-system>
    <!-- loading-->
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
  </div>
</template>

<script>
import NewSystem from "./Index/NewSystem"
import UpdateSystem from "./Index/UpdateSystem"
import AddSystem from "./Index/AddSystem"
export default {
  name: "System",
  components: {
    "i-new-system": NewSystem,
    "i-add-system": AddSystem,
    "i-update-system": UpdateSystem,
  },
  data() {
    return {
      types: ["中国版", "世界版"],
      typeitme: "中国版",
      categorytype: "china",
      total: 10,
      current: 1,
      pageSize: 10,
      columns: [
        {
          type: "selection",
          width: 30,
          align: "center",
          resizable: true,
        },
        {
          title: "指标",
          key: "name",
          minWidth: 200,
          align: "left",
          resizable: true,
          tree: true,
        },
        {
          title: "操作",
          key: "operation",
          slot: "operation",
          align: "center",
          width: 350,
          resizable: true,
        },
      ],
      isShowDeleteModal: false, //删除体系
      articleData: [],
      isShowAddSystem: false,
      isShowNewSystem: false,
      updateSystem: false,
      search: "",
      addSystemName: "",
      addSystemTypeName: "",
      updateSystemId: "",
      updateSystemParentId: "",
      updateSystemName: "",
      confirmDeleteModal: false,
      confirmDeleteAllModal: false,
      modalRow: "",
      showLoading: false,
      selectionId: [],
      selection_name: [],
      deleteType: "",
      listAll: [],
      listNum: [],
      systemPath: "",
      typeName: "",
      metaInfo: {},
      parentId: "",
    }
  },
  methods: {
    tabchange(name) {
      if (name == 0) {
        this.categorytype = "china"
      } else {
        this.categorytype = "world"
      }
      this.getSystemList()
    },
    // 添加二级指标
    addSecondZhibiao(row) {
      this.isShowNewSystem = true
      this.addSystemName = ""
      this.addSystemTypeName = row.category
      this.parentId = row.id
    },
    //新增一级指标
    addSystem() {
      this.isShowAddSystem = true
      this.addSystemName = ""
      this.addSystemTypeName = ""
    },
    //取消新增指标
    cancelAddCategory() {
      this.isShowNewSystem = false
      this.isShowAddSystem = false
    },
    // 取消修改指标
    cancelUpdateSystem() {
      this.updateSystem = false
    },
    //新增指标成功
    confirmAdd() {
      this.isShowAddSystem = false
      this.isShowNewSystem = false
      this.search = ""
      this.getSystemList()
      this.$Message.success("新增指标成功")
    },
    // 删除属性
    DeleteShuxing(row) {
      this.$Modal.confirm({
        title: `确认删除[${row.name}]吗`,
        onOk: () => {
          this.handDeleteClick(row)
        },
      })
    },
    //递归获取全部
    getListAll(row) {
      row.forEach((item) => {
        if (item.children != null && item.children.length > 0) {
          this.listAll.push(item)
          row = item.children
          this.getListAll(row)
        } else {
          this.listAll.push(item)
        }
      })
    },
    //获取没有父节点也没有子节点的节点下标，以修改样式
    getListNum(row) {
      row.forEach((item, index) => {
        if (item.children && item.children.length < 1 && item.parent_id === null) {
          if (this.listNum.indexOf(index) === -1) this.listNum.push(index)
        }
      })
    },
    changeCSS(row) {
      row.forEach((item) => {
        let selfItem = item
        setTimeout(() => {
          let dom1 = document.querySelectorAll(".ivu-table-row")[selfItem]
          let dom2 = dom1.querySelectorAll(".ivu-table-cell")[1]
          dom2.classList.add("place-holder")
        }, 1000)
      })
    },
    //递归获取分类路径
    getPath(row) {
      if (this.systemPath === "") {
        this.systemPath = " "
      } else {
        this.systemPath = row.name + "/" + this.systemPath
      }
      this.listAll.forEach((item) => {
        if (item.id === row.parent_id) {
          this.getPath(item)
        }
      })
    },
    //修改分类
    handleUpdateSystem(row) {
      this.typeName = row.type_name ? row.type_name : ""
      this.metaInfo = row.meta_info ? JSON.stringify(row.meta_info) : ""
      if (this.metaInfo === "{}") this.metaInfo = ""
      this.systemPath = ""
      this.getPath(row)
      this.updateSystemId = row.id
      this.updateSystemName = row.name
      this.updateSystem = true
    },
    // //修改分类成功
    confirmUpdate() {
      this.updateSystem = false
      this.getSystemList()
      this.$Message.success("修改指标名称成功")
    },
    // 列表选中
    selection_change(selection) {
      this.selectionId = []
      this.selection_name = []
      if (selection.length > 0) {
        selection.forEach((item) => {
          this.selectionId.push(item.id)
          this.selection_name.push(item.name)
        })
      }
    },
    //批量删除确认框
    confirmModal2() {
      if (this.selectionId.length > 0) {
        this.confirmDeleteAllModal = true
      } else {
        this.$Message.error("请选择分类")
      }
    },
    //删除指标
    async handDeleteClick(row) {
      const self = this
      self.showLoading = true
      try {
        this.deleteType = ""
        const res = await self.axios({
          method: "delete",
          url: self.$store.state.baseurl + "/api/bi/indicator_del",
          params: {
            data_id: row.id,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.getSystemList()
          this.$Message.info("删除成功")
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
        }
      } catch (error) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + error)
      }
    },
    // 处理数据
    getDataInfo(data) {
      let newArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].parent_id == null) {
          newArr.push({
            name: data[i].name,
            children: [],
            id: data[i].id,
            category: data[i].category,
            is_synthesis: data[i].is_synthesis,
          })
        } else {
          for (let j = 0; j < newArr.length; j++) {
            if (newArr[j].name == data[i].parent_id.name) {
              newArr[j].children.push({
                name: data[i].name,
                parent_id: newArr[j].id,
                id: data[i].id,
                category: data[i].category,
                is_synthesis: data[i].is_synthesis,
              })
            }
          }
        }
      }
      return newArr
    },
    //获取列表
    async getSystemList() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: self.$store.state.baseurl + "api/bi/indicator_list",
          params: {
            category: this.categorytype,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.articleData = this.getDataInfo(res.data.data.page)
          //获取数据条数
          this.total = this.articleData.length
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
      }
    },
  },
  mounted() {
    this.getSystemList()
  },
  watch: {
    articleData() {
      //先重置listAll、listNum再进行递归，避免数据重复
      this.listAll = []
      this.getListAll(this.articleData)
      this.listNum = []
      this.getListNum(this.listAll)
      this.changeCSS(this.listNum)
    },
  },
}
</script>

<style scoped>
.systembox {
  margin: 30px;
  padding: 15px;
}
.article-top {
  margin-top: 10px;
  margin-bottom: 10px;
}
.article-button {
  margin-right: 5px;
}
.article-search {
  min-width: 50px;
}
.article-search .search {
  margin-left: 20px;
}
.article-main {
  padding: 0 20px;
}
.enabledIcon {
  width: 15px;
  height: 15px;
  background: #4ad966;
  border-radius: 50%;
  margin: 0 auto;
}
.disabledIcon {
  width: 15px;
  height: 15px;
  background: #e71109;
  border-radius: 50%;
  margin: 0 auto;
}
.article-button1 {
  margin-right: 10px;
}
@media (max-width: 991px) {
}
@media (min-width: 992px) {
  .article-button1 {
    width: 100px;
    margin-right: 10px;
    padding: 0;
  }
  .divbtn {
    margin-left: 5px;
    width: 220px;
  }
}
>>> .ivu-table-cell {
  padding: 5px !important;
}
>>> .ivu-modal-mask {
  background: rgba(55, 55, 55, 0.1);
}
>>> .place-holder {
  margin-left: 20px;
}
.add-button {
  margin: 0 auto 15px auto;
  font-size: 16px;
}
.operate-icon {
  margin-right: 5px;
}
>>> .place-holder {
  margin-left: 20px;
}
</style>
<style>
/* // 改变选项卡的格式 */
.ivu-tabs-tab {
  font-size: 22px !important;
  /* width: 90px; */
  height: 50px !important;
  line-height: 40px !important;
}
.ivu-tabs-nav-container {
  height: 50px !important;
}
</style>
